import { Badge, Card, Text } from '@radix-ui/themes';
import clsx from 'clsx';
import type { ComponentProps } from 'react';
import type { ClosedMessageDocument } from '@hubertai/screening-question-types';
import type { TChatCollection } from 'types/scores.types';
import AnswerEvaluation from '../AnswerEvaluation';

interface CandidateMessageProps extends ComponentProps<'div'> {
  collection: TChatCollection;
  answer: ClosedMessageDocument;
}

const CandidateSingleSelectAnswer = ({ collection, answer, ...props }: CandidateMessageProps) => {
  return (
    <div {...props} className={clsx('flex flex-col justify-end gap-2')}>
      <div {...props} className={clsx('flex flex-row justify-end gap-2')}>
        <Card className={clsx('max-w-[80%]', 'flex flex-col justify-between', 'p-2')}>
          <Text as="div" size="2" color="gray">
            {/* Echoed from the candidate payload — must never be rendered as HTML (XSS) */}
            <div>{answer.text ?? ''}</div>
          </Text>
        </Card>

        <AnswerEvaluation evaluation={collection.evaluation && collection.evaluation.evaluation} />
      </div>
      <div className={clsx('flex flex-row justify-end gap-4')}>
        {answer.reusage && answer.reusage.is_reused ? (
          <Badge variant="soft" color="blue" size="1" className="w-fit">
            {answer.reusage?.is_edited ? 'Reused answer: edited' : 'Reused answer: Not edited'}
          </Badge>
        ) : null}

        {answer.channel && answer.channel.length ? (
          <Badge
            variant="soft"
            color="blue"
            size="1"
            className="w-fit"
            style={{
              fontSize: '8px',
              fontWeight: 500,
              letterSpacing: '0.3px',
              textTransform: 'uppercase',
              opacity: 0.8,
            }}
          >
            {answer.channel.split('_').join(' ')}
          </Badge>
        ) : null}
      </div>
    </div>
  );
};

export default CandidateSingleSelectAnswer;
